"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewBodyCell = exports.OverviewDayCellHeader = exports.DayCellHeader = exports.DayCell = exports.BaseCell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const date_1 = require("@bemlo/date");
const constants_1 = require("../../../constants");
const elements_1 = require("../../../elements");
const constants_2 = require("../utils/constants");
exports.BaseCell = (0, styled_1.default)(elements_1.Div) `
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left: ${constants_1.theme.border.style.thinLight};
`;
const BodyCell = (0, styled_1.default)(exports.BaseCell) `
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
`;
const DayCell = ({ onClick, day, viewState, weekDisabled, getDayCellStatus, }) => {
    const { color, backgroundColor, icon, isDaySelectable } = getDayCellStatus(day, !!weekDisabled, viewState);
    return ((0, jsx_runtime_1.jsxs)(BodyCell, { as: onClick ? elements_1.Clickable : undefined, onClick: onClick, disabled: !isDaySelectable, color: color, backgroundColor: backgroundColor, children: [day.date.format('DD'), icon && ((0, jsx_runtime_1.jsx)(elements_1.Icon, { design: icon.design, name: icon.name, color: color, size: "sm" }))] }));
};
exports.DayCell = DayCell;
const DayCellHeader = ({ index, children, }) => ((0, jsx_runtime_1.jsxs)(exports.BaseCell, { children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, children: (0, date_1.dayjsEn)()
                .day(index + 1)
                .format('ddd') }), children] }));
exports.DayCellHeader = DayCellHeader;
const OverviewDayCellHeader = ({ date, status, }) => {
    return ((0, jsx_runtime_1.jsxs)(exports.BaseCell, { styles: status === 'none' ? constants_2.DISABLED_DAY_STYLE : undefined, children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { children: date.format('ddd') }), (0, jsx_runtime_1.jsx)(elements_1.Text, { children: date.format('DD') })] }));
};
exports.OverviewDayCellHeader = OverviewDayCellHeader;
const getOverviewBodyCellStyles = (status) => {
    switch (status) {
        case 'none':
            return constants_2.DISABLED_DAY_STYLE;
        case 'tendered':
            return constants_2.VIEW_TENDERED_DAY_STYLE;
        case 'presented': {
            return {
                color: constants_1.Color.DARK_YELLOW,
                backgroundColor: constants_1.Color.YELLOW,
                icon: {
                    design: 'outline',
                    name: 'QuestionMarkCircleIcon',
                },
            };
        }
        case 'booked':
            return constants_2.BOOKED_DAY_STYLE;
        case 'rejected':
            return constants_2.REJECTED_DAY_STYLE;
    }
};
const OverviewBodyCell = ({ status, }) => {
    const { color, backgroundColor, icon } = getOverviewBodyCellStyles(status);
    return ((0, jsx_runtime_1.jsx)(exports.BaseCell, { styles: { color, backgroundColor }, children: icon && ((0, jsx_runtime_1.jsx)(elements_1.Icon, { design: icon.design, name: icon.name, color: color, size: "md" })) }));
};
exports.OverviewBodyCell = OverviewBodyCell;
